import { useState } from 'react';

interface UseSmartSearchModalProps {
  isV1ModalOpen: boolean;
  openV1Modal: () => void;
  closeV1Modal: () => void;
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useSmartSearchModal = (): UseSmartSearchModalProps => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isV1ModalOpen, setIsV1ModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openV1Modal = () => {
    setIsV1ModalOpen(true);
  };

  const closeV1Modal = () => {
    setIsV1ModalOpen(false);
  };

  return {
    isV1ModalOpen,
    openV1Modal,
    closeV1Modal,
    isModalOpen,
    openModal,
    closeModal,
  };
};
